(function () {
    window.addEventListener('load', onLoad, false);

    function onLoad() {
        const docfavUrl = document.getElementById('docfavUrl').dataset.docfavUrl;
        const apiUrl = docfavUrl + '/api-backend';
        const form = document.getElementById('contact-page-form');
        const errorContainer = form.querySelector('.error-msg');

        form.onsubmit = (event) => {
            event.preventDefault();
            event.stopPropagation();

            const formData = new FormData(event.target);
            const reqBody = {};

            for (const pair of formData.entries())
                reqBody[pair[0]] = pair[1];

            $.post(apiUrl + '/v1/es_ES/leads/contact', reqBody, res => {
                form.parentNode.removeChild(form);
                document.querySelector('.form-submit-success.d-none').classList.remove('d-none');
            })
                .fail(err => {
                    errorContainer.innerHTML = err?.responseJSON?.messages || err.statusText;
                    console.error(err);
                })
        }
    }
})();
